import React,{ useState,useEffect } from 'react';

import { Outlet } from 'react-router-dom';
import Foot from './components/foot/Foot';

import {init} from './utils/ethers'
// const mapStateToProps=(state)=>{
//     return{
//         showLoading:state.showLoading
//     }
// }

// setTimeout(() => {
//     init().then(res=>{
//         // message.success(t('head.连接成功'))
//     })
// }, 2000);
// console.log("app")
const App = () => {
    return (
        <>
           {/* {
               props.showLoading?<Loading/>:null
           } */}
            <Outlet />
            
             {/* <Foot/> */}
        </>
    );
}

export default App;
